import angular from "angular";

export function changePriceOption(obj, id) {
    const scope = angular.element(obj).scope();

    scope.editPriceOption = false;
    scope.changePriceOption(
        scope.priceOptionItem[ id ], 
        'save', 
        scope.priceOptionItem[ id ].key, 
        obj.value
    );
}
